<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>VENTAS DEL AÑO {{ year }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="year"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                            @change="getMonthlySales"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="chartOptions"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>VENTAS + BOLSITAS SIN CERRAR DEL AÑO {{ year }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="yearForSaleAndPartialSale"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                            @change="getMonthlySalesAndPartialSales"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="chartOptionsForSaleAndPartialSale"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>LOS {{top}} PRODUCTOS MÁS VENDIDOS DEL AÑO</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="top"
                            :items="select.top"
                            item-value="id"
                            item-text="name"
                            label="¿Cuantos productos desea ver?"
                            dense
                            outlined
                            @change="getBestSellingProducts"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="lineChartOptions"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>{{ topD4 }} PRODUCTOS MÁS VENDIDOS DEL {{ monthD4 }}/{{ yearD4 }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="topD4"
                            :items="select.top"
                            item-value="id"
                            item-text="name"
                            label="¿Cuantos productos desea ver?"
                            dense
                            outlined
                            @change="bestSellingProductsPerMonth"
                          ></v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="monthD4"
                            :items="select.month"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                            @change="bestSellingProductsPerMonth"
                          ></v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="yearD4"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="¿Cuantos productos desea ver?"
                            dense
                            outlined
                            @change="bestSellingProductsPerMonth"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="chartOptionsBestSellingProductsPerMonth"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>


      <template>
        <v-snackbar
          v-model="snackbar"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import { Chart } from 'highcharts-vue'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'InicioView',
    components: {
      DefaultLayout,
      highcharts: Chart
    },
    data () {
      return {
        overlay: false,
        panel: [0, 1, 2, 3],
        year: moment().format("YYYY"),
        yearForSaleAndPartialSale: moment().format("YYYY"),
        top: 5,
        topD4: 10,
        monthD4: moment().format("MM"),
        yearD4: moment().format("YYYY"),
        select: {
          year: [
            { id: '2021', name: '2021' },
            { id: '2022', name: '2022' },
            { id: '2023', name: '2023' },
            { id: '2024', name: '2024' },
            { id: '2025', name: '2025' },
            { id: '2026', name: '2026' }
          ],
          top: [
            { id: 5, name: '5' },
            { id: 10, name: '10' },
            { id: 15, name: '15' },
            { id: 20, name: '20' }
          ],
          month: [
            { id: '01', name: 'ENERO' },
            { id: '02', name: 'FEBRERO' },
            { id: '03', name: 'MARZO' },
            { id: '04', name: 'ABRIL' },
            { id: '05', name: 'MAYO' },
            { id: '06', name: 'JUNIO' },
            { id: '07', name: 'JULIO' },
            { id: '08', name: 'AGOSTO' },
            { id: '09', name: 'SEPTIEMBRE' },
            { id: '10', name: 'OCTUBRE' },
            { id: '11', name: 'NOVIEMBRE' },
            { id: '12', name: 'DICIEMBRE' }
          ]
        },
        date: moment().toISOString().substr(0, 10),
        hoy: moment().format("DD MMMM YYYY"),
        chartOptions: {
          chart: {
            type: 'column'
          },
          title: {
            text: 'VENTAS DEL AÑO'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: `total ventas en S/.`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: 'S/.{point.y:.1f}'
              }
            }
          },
          series: [{
            name: 'Ventas',
            colorByPoint: true,
            data: []
          }]
        },
        chartOptionsForSaleAndPartialSale: {
          chart: {
            type: 'column'
          },
          title: {
            text: 'VENTAS + BOLSITAS SIN CERRAR<br>DEL AÑO'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: `total ventas en S/.`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: 'S/.{point.y:.1f}'
              }
            }
          },
          series: [{
            name: 'Ventas',
            colorByPoint: true,
            data: []
          }]
        },
        lineChartOptions: {
          chart: {
            type: 'line'
          },
          title: {
              text: 'Productos con más ventas',
              align: 'left'
          },

          subtitle: {
              text: 'Visualizar: <a href="https://admin.dino-toys.com/#/manage/product" target="_blank">PRODUCTOS</a>.',
              align: 'left'
          },

          yAxis: {
              title: {
                  text: 'Cantidad vendida'
              }
          },

          xAxis: {
              categories: [
                  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                  'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'
              ],
              accessibility: {
                  description: 'Months of the year'
              }
          },

          legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle'
          },

          tooltip: {
              crosshairs: true,
              shared: true
          },

          plotOptions: {
              spline: {
                  marker: {
                      radius: 4,
                      lineColor: '#666666',
                      lineWidth: 1
                  }
              }
          },

          series: [],

          responsive: {
              rules: [{
                  condition: {
                      maxWidth: 500
                  },
                  chartOptions: {
                      legend: {
                          layout: 'horizontal',
                          align: 'center',
                          verticalAlign: 'bottom'
                      }
                  }
              }]
          }
        },
        chartOptionsBestSellingProductsPerMonth: {
          chart: {
            type: 'column'
          },
          title: {
            text: 'VENTAS DEL AÑO'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: `unidades`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: [{
            name: 'Ventas',
            colorByPoint: true,
            data: []
          }]
        },
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getMonthlySales: function () {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.MONTHLY_SALES_LISTS.replace(':year', this.year))
        .then(response => {
          let list = [];
          response.data.forEach((value, index) => {
            list.push({'y': value.total, 'name': moment(value.created_at).format("MMMM")});
          });
          this.chartOptions.series[0].data = list;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getMonthlySalesAndPartialSales: function () {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.MONTHLY_SALES_AND_PARTIAL_SALES_LISTS.replace(':year', this.year))
        .then(response => {
          let list = [];
          response.data.forEach((value, index) => {
            list.push({'y': value.total, 'name': moment(value.created_at).format("MMMM")});
          });
          this.chartOptionsForSaleAndPartialSale.series[0].data = list;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getBestSellingProducts: function () {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_BEST_SELLING_PRODUCTS.replace(':top', this.top))
        .then(response => {
          this.lineChartOptions.series = response.data;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      bestSellingProductsPerMonth: function () {
        this.overlay = true;
        axios.get(
          process.env.DINO.PATH.GET_BEST_SELLING_PRODUCTS_PER_MONTH
            .replace(':year', this.yearD4)
            .replace(':month', this.monthD4)
            .replace(':top', this.topD4)
          )
        .then(response => {
          let list = [];
          response.data.forEach((value, index) => {
            list.push({
              'y': Number(value['order_detail.quantity_units_product']), 
              'name': value['order_detail.product.name']
            });
          });

          this.chartOptionsBestSellingProductsPerMonth.series[0].data = list;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      logout: function() {
        localStorage.clear();
        window.location.href = "/";
      }
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getMonthlySales();
      this.getBestSellingProducts();
      this.getMonthlySalesAndPartialSales();
      this.bestSellingProductsPerMonth();
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Inicio.vue